export const STATE_RESET_ACTION_PREFIX = 'setInitial';

export const AppMutations = {
  SetPageTitle: 'SetPageTitleMutation',
  SetUserLocale: 'SetUserLocaleMutation',
  RetrieveSessionSuccess: 'RetrieveSessionSuccess',
  ToggleUserType: 'ToggleUserTypeMutation',
  SetLoading: 'SetLoading',
  DismissSession: 'DismissSession',
  RetrieveGlobalValuesSuccess: 'RetrieveGlobalValuesSuccess',
  RetrieveUnreadNotificationCountSuccess: 'RetrieveUnreadNotificationCountSuccess',
  SetRedirect: 'AppMutaions.SetRedirect',
  UpdateRefreshTokenModalIsVisible: 'AppMutations.UpdateRefreshTokenModalIsVisible',
  SetFirstTimeApplicationAccess: 'AppMutations.SetFirstTimeApplicationAccess',
  UpdateLastActiveTime: 'AppMutations.UpdateLastActiveTime',
  ResetSessionInactiveTime: 'AppMutations.ResetSessionInactiveTime',
  InsertTimeOutReferences: 'AppMutations.InsertTimeOutReferences',
  SetSessionRefreshTime: 'AppMutations.SetSessionRefreshTime',
  ResetAllModulesStates: 'AppMutations.ResetAllModulesStates',
  UpdateIsRecentUser: 'AppMutations.UpdateIsRecentUser',
  UpdateAccountVerificationRequired: 'AppMutations.UpdateAccountVerificationRequired'
};

export const AppActions = {
  SetPageTitle: 'SetPageTitleAction',
  SetUserLocale: 'SetUserLocale',
  RetrieveSession: 'RetrieveSession',
  ToggleUserType: 'ToggleUserTypeAction',
  DismissSession: 'DismissSession',
  RetrieveGlobalValues: 'RetrieveGlobalValues',
  RetrieveUnreadNotificationCount: 'RetrieveUnreadNotificationCount',
  SetUserUnreadNotificationCount: 'SetUserUnreadNotificationCount',
  RetrieveRecentMenuItems: 'AppActions.RetrieveRecentItems',
  RetrieveRecentItemsList: 'AppActions.retrieveRecentItemsList',
  SetFirstTimeApplicationAccess: 'AppActions.SetFirstTimeApplicationAccess',
  RefreshSession: 'AppActions.RefreshSession',
  SetRefreshTokenModalIsVisible: 'AppActions.SetRefreshTokenModalIsVisible',
  UpdateLastActiveTime: 'AppActions.UpdateLastActiveTime',
  ResetSessionInactiveTime: 'AppActions.ResetSessionInactiveTime',
  InsertTimeOutReferences: 'AppActions.InsertTimeOutReferences',
  SetSessionRefreshTime: 'AppActions.SetSessionRefreshTime',
  AutoRefreshSession: 'AppActions.AutoRefreshSession',
  SetRedirect: 'AppActions.SetRedirect',
  ResetAllModulesStates: 'AppActionsResetAllmodulesStates',
  SetIsRecentUser: 'AppActions.SetIsRecentUser',
  SetAccountVerificationRequired: 'AppActions.SetAccountVerificationRequired'
};

export const AppGetters = {
  AssignmentRates: 'AppGetters.AssignmentRateTypes',
  BranchNames: 'AppGetters.BranchNames',
  ProvinceAbbreviations: 'AppGetters.ProvinceAbbreviations',
  ClientRebates: 'AppGetters.ClientRebates',
  EntityTypes: 'AppGetters.EntityTypes',
  ContractorSources: 'AppGetters.ContractorSources',
  PhoneTypes: 'AppGetters.PhoneTypes',
  DivisionAbbrs: 'AppGetters.DivisionAbbrs',
  Departments: 'AppGetters.Departments',
  AssignmentEndReasons: 'AppGetters.AssignmentEndReasons',
  ProvinceNames: 'AppGetters.ProvinceNames',
  Provinces: 'AppGetters.Provinces',
  RefreshTokenModalIsVisible: 'AppGetters.RefreshTokenModalIsVisible',
  IbmLineOfBusiness: 'AppGetters.IbmLineOfBusiness',
  IbmSkillLevel: 'AppGetters.IbmSkillLevel',
  Reports: 'AppGetters.ReportsList',
  FirstTimeApplicationAccess: 'AppGetters.FirstTimeApplicationAccess',
  LastActiveTime: 'AppGetters.LastActiveTime',
  IsRecentUser: 'AppGetters.IsRecentUser',
  AccountVerificationRequired: 'AppGetters.AccountVerificationRequired',
  AccountVerificationUser: 'AppGetters.AccountVerificationUser',
  AccountVerificationUserFirstname: ' AppGetters.AccountVerificationUserFirstname'
};
